import { render, staticRenderFns } from "./AbkUserRegistrationForm.vue?vue&type=template&id=6bba2b8e&scoped=true&"
import script from "./AbkUserRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./AbkUserRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkUserRegistrationForm.vue?vue&type=style&index=0&id=6bba2b8e&scoped=true&lang=scss&"
import style1 from "./AbkUserRegistrationForm.vue?vue&type=style&index=1&id=6bba2b8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bba2b8e",
  null
  
)

export default component.exports